<template>
  <node-view-wrapper
    contenteditable="false"
    class="editable-shorttag-block"
  >
    <div
      class="content"
      draggable="true"
      data-drag-handle
    >
      <!-- Gerendete Komponente als Vorschau -->
      <faq-list
        :list-elements="node.attrs.listElements"
        :list-header="node.attrs.listHeader"
        :list-description="node.attrs.listDescription"
        :answer-collapsible="node.attrs.answerCollapsible"
      />
      <!-- Modal Opener Button mit Daten für die Inputs  -->
      <faq-list-btn
        btn-type="update"
        :header-prop="nodeProps.listHeader"
        :description-prop="nodeProps.listDescription"
        :elements-prop="nodeProps.listElements"
        :answer-collapsible-prop="nodeProps.answerCollapsible"
        @update-content="tiptapContentUpdate"
      />
    </div>
  </node-view-wrapper>
</template>

<script>
import {
  NodeViewWrapper,
  nodeViewProps,
} from '@tiptap/vue-2';
import { sha256 } from 'js-sha256';
import FaqList from '../FaqList.vue';
import FaqListBtn from './FaqListBtn.vue';

export default {
  components: {
    NodeViewWrapper,
    FaqList,
    FaqListBtn,
  },
  props: {
    ...nodeViewProps,
    ...FaqList.props,
  },
  computed: {
    nodeProps() {
      return this.node?.attrs;
    },
    // needed for re-rendering if user changes some img src
    nodePropsKey() {
      return sha256(JSON.stringify(this.node?.attrs));
    }
  },
  methods: {
    tiptapContentUpdate(updateData) {
      this.updateAttributes(updateData.attrs);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>


<style lang="scss" scoped>
.content {
  cursor: grab;
}
</style>
